import { BadgeVariant } from "shared/components";
import {
  OurPetPolicyStatusEnum,
  PetScreeningStatusEnum,
  PetVerificationStatusEnum
} from "./types";
import { useCallback } from "react";

export const usePetScreeningUtils = () => {
  const statusBadgeVariant = useCallback(
    (status: OurPetPolicyStatusEnum | PetScreeningStatusEnum): BadgeVariant => {
      switch (status) {
        case OurPetPolicyStatusEnum.PENDING:
        case PetScreeningStatusEnum.pending:
          return BadgeVariant.WARNING;
        case OurPetPolicyStatusEnum.APPROVED:
        case PetScreeningStatusEnum.approved:
          return BadgeVariant.SUCCESS;
        case OurPetPolicyStatusEnum.NOT_APPROVED:
        case PetScreeningStatusEnum.not_approved:
          return BadgeVariant.ERROR;
        default:
          return BadgeVariant.BASE;
      }
    },
    []
  );

  const verificationBadgeVariant = useCallback(
    (status: PetVerificationStatusEnum): BadgeVariant => {
      if (status === PetVerificationStatusEnum.VERIFIED)
        return BadgeVariant.SUCCESS;
      return BadgeVariant.BASE;
    },
    []
  );

  return {
    statusBadgeVariant,
    verificationBadgeVariant
  };
};
